import styled from '@grebban/style-system-react';
import useAppSelector from '@sportson/core-web/hooks/useAppSelector';
import { above } from '@sportson/core-web/utils/mediaqueries';
import Text from 'components/Text';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import React from 'react';
import { shallowEqual } from 'react-redux';

const Wrapper = styled('div')`
    ${above['desktop.sm']} {
        width: 413px;
    }
`;

const DescriptionWrapper = styled('div')`
    grid-column: 9 / span 4;
`;

interface BrandDescriptionProps {}

export const BrandDescription: React.FC<BrandDescriptionProps> = () => {
    const settings: any = useAppSelector(({ page }) => page?.data?.settings, shallowEqual);
    const { description } = settings || {};

    if (!description) {
        return null;
    }

    return (
        <Wrapper>
            <DescriptionWrapper gridColumn="1 / span 8">
                <Wysiwyg
                    data={description}
                    TextComponent={(props) => <Text typography="Content/20_140_0_350" {...props} />}
                />
            </DescriptionWrapper>
        </Wrapper>
    );
};

export default BrandDescription;
